import { useQuery } from '@tanstack/react-query'

import { useTRPC } from '@langmail/shared-ui'

import { Skeleton } from '@/components/ui/skeleton'
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table'

export function AdminPage() {
  const trpc = useTRPC()

  const usersQuery = useQuery({ ...trpc.admin.listUsers.queryOptions() })

  return (
    <div className="flex-1 overflow-auto">
      <div className="mx-auto max-w-[900px] p-8 pt-12">
        <h1 className="mb-2 font-semibold text-[28px]">Users</h1>
        <p className="mb-8 text-muted-foreground text-sm">
          {usersQuery.data ? `${usersQuery.data.length} users` : null}
        </p>

        {usersQuery.isLoading ? (
          <div className="space-y-2">
            {Array.from({ length: 5 }).map((_, i) => (
              <Skeleton className="h-12 w-full" key={i} />
            ))}
          </div>
        ) : null}

        {usersQuery.isError ? (
          <p className="text-muted-foreground text-sm">Failed to load users. {usersQuery.error.message}</p>
        ) : null}

        {usersQuery.data ? (
          <div className="rounded-lg border bg-card">
            <Table>
              <TableHeader>
                <TableRow>
                  <TableHead>Email</TableHead>
                  <TableHead>Name</TableHead>
                  <TableHead>Created</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {usersQuery.data.map((user) => (
                  <TableRow key={user.id}>
                    <TableCell className="font-medium">{user.email ?? '—'}</TableCell>
                    <TableCell className="text-muted-foreground">{user.name ?? '—'}</TableCell>
                    <TableCell className="text-muted-foreground">
                      {new Date(user.createdAt).toLocaleDateString()}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
        ) : null}
      </div>
    </div>
  )
}
